var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('settings',{attrs:{"title":"Population","description":"Filter by the population (e.g. Parenting Youth)"}},[_c('v-select',{staticClass:"mt-2 mx-2",attrs:{"clearable":"","placeholder":"All","multiple":"","items":_vm.populations,"value":_vm.value,"chips":""},on:{"change":val => _vm.$emit('input', val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }